exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".news-component{border:none}.news-component .news-banner{padding-top:24px;padding-bottom:12px}.news-component .news-banner__text-holder{position:relative;height:256px;padding:24px;color:#fff}.news-component .news-banner__text{position:absolute;bottom:12px;left:24px;right:24px}.news-component .news-banner__image-holder{position:relative;height:256px;border-radius:8px 8px 0 0;background-repeat:no-repeat;background-position-y:top;background-position-x:center;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover}.news-component .news-banner__overlay{border-radius:8px 8px 0 0;position:absolute;top:0;bottom:0;right:0;left:0;background:rgba(0,0,0,.3)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/news.scss
// module id = 1022
// module chunks = 0